import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=fdf7be20&scoped=true&"
import script from "./comment.vue?vue&type=script&lang=js&"
export * from "./comment.vue?vue&type=script&lang=js&"
import style0 from "./comment.vue?vue&type=style&index=0&id=fdf7be20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf7be20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdf7be20')) {
      api.createRecord('fdf7be20', component.options)
    } else {
      api.reload('fdf7be20', component.options)
    }
    module.hot.accept("./comment.vue?vue&type=template&id=fdf7be20&scoped=true&", function () {
      api.rerender('fdf7be20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/task_manage/notice_manage/form/components/comment.vue"
export default component.exports